import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_EXPORT_ACTION,
  ITableAction,
  NEW_ENTRY_ACTION,
  TableControlComponent,
  TableControlModule,
} from 'frontier/browserkit';
import AppControlGuids from '../../../api/ControlGuids';

@Component({
  selector: 'app-dataoffice-table',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
  providers: [{provide: TableControlComponent, useExisting: DataofficeTableComponent}],
})
export class DataofficeTableComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TDataOfficeTableView;
  override tableName: string = 'Datenannahmestellen';

  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    NEW_ENTRY_ACTION,
    CSV_EXPORT_ACTION,
  ]);
}
